import { greys } from "@clockwise/web-commons/src/styles/color.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";
import { CSSProperties } from "react";

export const container: CSSProperties = {
  minHeight: "100%",
  position: "relative",
  overflowY: "auto",
  overflowX: "hidden",
  display: "flex",
  flexDirection: "column",
};

export const divider: CSSProperties = {
  width: "100%",
  left: 0,
  backgroundColor: greys.paleGrey,
};

export const buttonContainer: CSSProperties = {
  bottom: 0,
  zIndex: 1,
  background: greys.white,
  padding: `${spacing.std}px ${spacing.sm}px ${spacing.std}px ${spacing.sm}px`,
};
